import React, { useState, useCallback } from 'react';
import { Popover } from '@mantine/core';
import { useEventListener } from 'ahooks';
import { Icon } from '@shakkerai/components';

const StylePicker = React.memo(({ value, onChange, defOption, targetKey, options }) => {
  const roleKey = `style-type-picker-entry-${targetKey}`;
  const [opened, setOpened] = useState(false);

  const setPickerOpen = () => {
    setOpened(!opened);
  };

  const handleGlobalClick = useCallback((event) => {
    if (event.target?.closest(`[data-role="${roleKey}"]`)) {
      return;
    }

    setOpened(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEventListener('click', handleGlobalClick);
  const selectedText = value ? options.find((o) => o.code === value).tagLabel : defOption;
  return (
    <Popover opened={opened} position="bottom-end" shadow="xl">
      <Popover.Target>
        <button
          data-role={roleKey}
          onClick={() => setPickerOpen()}
          className="flex flex-shrink-0 items-center text-[13px] text-[#2d2d2d] font-normal mr-2"
        >
          <span>{selectedText}</span>
          <Icon className={`ml-1 shk-kuangjia-xiala ${opened ? 'rotate-180' : ''}`} fontSize={18} color="inherit" />
        </button>
      </Popover.Target>
      <Popover.Dropdown w={132} classNames={{ dropdown: 'p-0 border-none rounded-sm shadow-light' }}>
        <div data-role="model-base-type-picker-wrapper" className="p-1.5">
          {[
            {
              code: '',
              tagLabel: '全部',
            },
          ]
            .concat(options)
            .map((item) => {
              const handleClick = () => {
                setOpened(false);
                if (value === item.code) return;
                onChange({
                  [targetKey]: item.code,
                });
              };
              const selected = value === item.code;
              return (
                <button
                  key={item.code}
                  onClick={handleClick}
                  className="group relative flex items-center w-[120px] h-[30px] bg-white hover:bg-[#f4f6f8] rounded-sm px-1.5 text-xs"
                >
                  <span className={`${selected ? 'text-primary' : ' text-[#2d2d2d2]'} text-xs`}>{item.tagLabel}</span>
                </button>
              );
            })}
        </div>
      </Popover.Dropdown>
    </Popover>
  );
});

export default StylePicker;
